const FINANCIAL_PLANNER_DRAFT_KEY = 'financial_planner_draft_v1';

export function loadPlannerDraft() {
  try {
    const raw = localStorage.getItem(FINANCIAL_PLANNER_DRAFT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || !parsed.data) return null;
    return parsed;
  } catch (error) {
    return null;
  }
}

export function savePlannerDraft(data, step, substepIndex) {
  try {
    localStorage.setItem(FINANCIAL_PLANNER_DRAFT_KEY, JSON.stringify({
      data,
      step,
      substepIndex,
      updatedAt: Date.now()
    }));
  } catch (error) {
    // Storage pieno o disabilitato: il planner continua a funzionare senza bozza
  }
}

export function clearPlannerDraft() {
  try {
    localStorage.removeItem(FINANCIAL_PLANNER_DRAFT_KEY);
  } catch (error) {
    // ignore
  }
}
